import { useEffect } from 'react';
import { useGlobal, useErrorHandler } from '@/hooks';
import { loadUserService } from '@/services';
import { useAppContext } from '@/context';

export const useAuth = () => {
  const global = useGlobal();
  const { dispatch, state } = useAppContext();
  const errorHandler = useErrorHandler();

  const loadUser = () => {
    loadUserService()
      .then((user) => dispatch({ action: 'set_auth_state', payload: { loaded: true, user } }))
      .catch(errorHandler);
  };

  const fillUser = () => {
    if (global?.user?.isFetched)
      dispatch({ action: 'set_auth_state', payload: { loaded: true, user: global.user.data } });
    else if (!state.risk.auth.loaded) loadUser();

    return () =>
      dispatch({
        action: 'set_auth_state',
        payload: {
          user: { typeDescription: null, id: null, company: { id: null, combo: { uuid: null, name: null } } },
          loaded: false,
        },
      });
  };

  useEffect(fillUser, []);

  return state.risk.auth;
};
